import { Button } from 'components';
import { RoutingUrls } from 'common/const';

interface IErrorCodeDescription {
  pageTitle: string;
  title: string;
  description: string;
  buttons: React.ReactNode[];
}

const error400: IErrorCodeDescription = {
  pageTitle: 'Ошибка: Неверные данные',
  title: '400',
  description: 'При отправке запроса, в нём были указаны неверные данные.',
  buttons: [
    <Button
      key={1}
      onClick={() => (window.location.href = RoutingUrls.Main)}
    >
      Вернуться на главную
    </Button>,
    <Button
      key={0}
      onClick={() => window.history.back()}
      color='transparent-blue'
    >
      Назад
    </Button>,
  ],
};

const error401: IErrorCodeDescription = {
  pageTitle: 'Ошибка: Нет доступа',
  title: '401',
  description: 'Страница требует авторизации, войдите на сайт для доступа к содержимому.',
  buttons: [
    <Button
      key={1}
      onClick={() => (window.location.href = RoutingUrls.Auth)}
    >
      Авторизация
    </Button>,
    <Button
      key={0}
      onClick={() => window.history.back()}
      color='transparent-blue'
    >
      Назад
    </Button>,
  ],
};

const error404: IErrorCodeDescription = {
  pageTitle: 'Ошибка: Не найдено',
  title: '404',
  description: 'Страница или объект, к которому вы обращаетесь, не найден.',
  buttons: [
    <Button
      key={1}
      onClick={() => (window.location.href = RoutingUrls.Main)}
    >
      Вернуться на главную
    </Button>,
    <Button
      key={0}
      onClick={() => window.history.back()}
      color='transparent-blue'
    >
      Назад
    </Button>,
  ],
};

const errorAny: IErrorCodeDescription = {
  pageTitle: 'Ошибка',
  title: 'T_T',
  description: 'Неожиданная ошибка при выполнении операции.',
  buttons: [
    <Button
      key={1}
      onClick={() => (window.location.href = RoutingUrls.Main)}
    >
      Вернуться на главную
    </Button>,
    <Button
      key={0}
      onClick={() => window.history.back()}
      color='transparent-blue'
    >
      Назад
    </Button>,
  ],
};

function getErrorData(errorCode: string | number | null | undefined): IErrorCodeDescription {
  const error = Number(errorCode);

  if (error === 400) {
    return error400;
  }

  if (error === 401) {
    return error401;
  }

  if (error === 404) {
    return error404;
  }

  return errorAny;
}

export default getErrorData;
